import * as React from 'react';
import {Modal, ModalProps} from 'react-bootstrap';
import { Style, StyleText } from '../../models';
import { ReportDataService, NotificationService } from '../../services';
import './Modal.css';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FilterStore, UserStore } from '../../stores';
import { BaseRouteProps } from '../../interfaces';
import { FoundationsReportContent } from '../reports';
import {PVABadge} from "../reports";

interface ModalContentProps extends ModalProps, BaseRouteProps<{}> {
    style: Style;
    name: string;
    notificationService: NotificationService;
    UserStore?: UserStore;
    FilterStore?: FilterStore;
    topic?: string;
    surveyVersion?: any;
    allStyles?: Style[];
    selectedUserData?: any;
    hideDichotomies?: boolean;
}

interface ModalState {
    generating: boolean;
}

@inject('UserStore', 'FilterStore') @observer
export class PVAStyleModal extends React.Component<ModalContentProps, ModalState> {
    private reportDataService = new ReportDataService(this.props.notificationService);

    constructor(props: ModalContentProps) {
        super(props);

        this.state = {
            generating: false
        };
    }

    @computed get surveyVersion() {
        if (this.props.surveyVersion) {
            return this.props.surveyVersion;
        }
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    public export = () => {
        this.setState(
            {
                generating: true
            },
            () => {
                let id: number = this.getCurrentStyle().id;
                this.reportDataService.getStylePDF(id, this.props.style.name).then(() => {
                    this.setState({
                                      generating: false
                                  });
                }).catch(() => {
                    this.setState({
                                      generating: false
                                  });
                });
            });
    }

    getCurrentStyle(): Style {
        let relevantStyle = this.props.style;
        if (this.props.allStyles && this.props.allStyles.length > 0) {
            relevantStyle = this.props.allStyles!.filter((style: Style) => {
                return style.name === this.props.style.name;
            })[0];
        }
        return relevantStyle;
    }

    render(): any {
        if (!this.props.show) return <div />;
        
        let relevantStyle = this.getCurrentStyle();
        const styleTexts = relevantStyle.styleTexts || [];
        const sortedAdditionalStyles = styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).sort((one: StyleText, two: StyleText) => {
            if (one.sort > two.sort) {
                return 1;
            } else if (one.sort < two.sort) {
                return -1;
            }
            return 0;
        });
        
        let title = (
            <div className="pva-style-modal-title">
                <div className="header">
                    <PVABadge style={this.props.style.name} badge={this.props.name} />
                    <div className="text">
                        <div className="topic font-subheading">{this.props.topic || ""}</div>
                        <div className="title font-heading">{this.props.style.name || ""}</div>
                    </div>
                </div>
                <div className="modal-closer" onClick={this.props.onHide as any}>
                    <img src="/images/close x.svg" />
                    <span className="modal-close-button font-heading">Close</span>
                </div>
            </div>
        );

        const currentStyleName = this.props.style.name.toLowerCase();
        const checkmarkUrl = `url("/images/checkmark-${currentStyleName}.svg")`;
        const checkMarkRedUrl = `url("/images/check-mark-${currentStyleName}.svg")`;

        return (
            <Modal 
                className="style-modal" 
                show={this.props.show} 
                onHide={this.props.onHide}
                style={{
                    '--active-tab-color': `var(--pva-${this.props.style.name.toLowerCase()})`,
                    '--custom-content-color': `var(--pva-${this.props.style.name.toLowerCase()})`,
                    '--checkmark-url': checkmarkUrl,
                    '--check-mark-url': checkMarkRedUrl
                } as any}
            >
                <Modal.Header>{title}</Modal.Header>
                <div className="pva-style-content-outer-container">
                    <FoundationsReportContent
                        UserStore={this.props.UserStore}
                        FilterStore={this.props.FilterStore}
                        notificationService={this.props.notificationService}
                        history={this.props.history}
                        location={this.props.location}
                        match={this.props.match}
                        useContentOnly={true}
                        selectedUserData={this.props.selectedUserData}
                        styleData={this.props.style}
                        hideDichotomies={this.props.hideDichotomies}
                    />
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PVAStyleModal.tsx